// De onde o usuário abriu o guia (drawer) da Jornada. Decide para onde o botão
// de voltar do header leva: a home da Jornada ou o módulo em que ele já estava.
//
// Sem isto o drawer sempre voltava para a home da Jornada — inclusive quando o
// usuário tinha entrado pela barra de progresso dentro do próprio módulo, o que
// o teletransportava para uma tela onde nunca esteve.
//
// A origem descreve a SESSÃO do guia, não a etapa: `goPrev`/`goNext` a preservam,
// porque quem entrou pelo módulo continua no mesmo fluxo ao andar entre etapas.

export const GUIDE_ORIGIN_JOURNEY = 'journey'
export const GUIDE_ORIGIN_MODULE = 'module'

// Canoniza para um dos dois valores. Origem ausente (guia aberto antes desta
// mudança, payload de localStorage antigo, typo como 'modulo') degrada para
// `journey` — o comportamento que já existia. Isso é o que permite ter UM branch
// (`=== GUIDE_ORIGIN_MODULE`) em vez de um terceiro estado espalhado pelo drawer,
// e é também a migração inteira do storage: nada de versionar chave.
export const normalizeGuideOrigin = (value) =>
  value === GUIDE_ORIGIN_MODULE ? GUIDE_ORIGIN_MODULE : GUIDE_ORIGIN_JOURNEY
